<template>
    <div>
        <el-button type="primary" @click="openFullScreen1" v-loading.fullscreen.lock="fullscreenLoading" style="display:none"></el-button>
        <el-form :inline="true" class="demo-form-inline">
			 <span @click="backList()" class="backuy"><i class="el-icon-back"></i></span>
                    <el-form-item label="应用类型:">
                        <span>{{currentDetailInfo.contestTypeStr}}</span>
                    </el-form-item>
                    <el-form-item label="应用面信息:">
                        <span v-show="currentDetailInfo.h">H:{{currentDetailInfo.h}}m  &nbsp; </span>
                        <span v-show="currentDetailInfo.w">W:{{currentDetailInfo.w}}m &nbsp; </span>
                        <span v-show="currentDetailInfo.d">D:{{currentDetailInfo.db}}m ~ {{currentDetailInfo.d}}m &nbsp; </span>
                        <span v-show="currentDetailInfo.w1">W1:{{currentDetailInfo.w1}}m &nbsp; </span>
                        <span v-show="currentDetailInfo.w2">W2:{{currentDetailInfo.w2}}m &nbsp; </span>
                    </el-form-item>
                    <el-form-item>
                        <span>{{colorFlag == 1 ? '单白' : '彩色'}}</span>
                    </el-form-item>
                    
                    <!-- <el-form-item label="参考项:" class="wid150">
                        <el-select v-model="chooseEchatType" multiple collapse-tags @change="initData">
                            <el-option v-for="item in echatTypeList" :key="item.value" :label="item.name" :value="item.value">{{item.name}}</el-option>
                        </el-select>
                    </el-form-item> -->
					<el-form-item label="灯具类型:" class="wid150">
                      <el-select v-model="searchLampType">
                        <el-option
                          v-for="item in lampTypeList"
                          :key="item.id"
                          :label="item.lampName"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    
                    <el-form-item label="功率≤:" class="widsets">
                      <el-input v-model="powerMin"><i slot="suffix"></i>w</el-input>
					  ~
                      <el-input v-model="powerMax"><i slot="suffix"></i>w</el-input>
                    </el-form-item>
					 <el-form-item label="下45°:" class="widsets">
                      <el-input v-model="lightIntensity3Min"></el-input>
					  ~
                      <el-input v-model="lightIntensity3Max"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="initData()">查询</el-button>
                    </el-form-item>
                </el-form>
              
         <div id="echarts" style="height:580px;width:900px;margin: 0"></div>
    </div>
</template>

<script>
export default {
  name: 'hello',
  data () {
    return {
		isfrist:false,
      fullscreenLoading:false,
      lampTypeList:[],
      searchLampType:'',
	  searchPower:'',
	  lightIntensity3Min:'',
	  lightIntensity3Max:'',
	  powerMin:'',
	  powerMax:'',
		currentDetailInfo:{},
		ids:'',
        echatTypeList : [
                { value: '3', name: '推荐·低'},
                { value: '4', name: '推荐·中'},
                { value: '5', name: '推荐·高'}],
        chooseEchatType:['3','4','5']
    }
  },
  props:['colorFlag','contestId','contestTypeStr'],
  mounted(){

  },
  methods: {
	  clearSearchParam(){
			this.searchLampType=''
			this.lightIntensity3Min=''
			this.lightIntensity3Max=''
			this.powerMin=''
			this.powerMax=''
	  },
	openFullScreen1() {
    	this.fullscreenLoading = true;
	},

	setContestDetetionIds(ids,req){
		this.ids = ids
		this.currentDetailInfo = req
	},
    generateArr(length,value){
        var dataArr = new Array(length);
        for(var i=0;i<dataArr.length;i++){
            dataArr[i] =value;
        }
        return dataArr;
    },
    backList(){
        this.$emit('backDetail');
    },
    initData(){
		if(!this.isfrist){
			this.searchLampType=''
			this.lightIntensity3Min=''
			this.lightIntensity3Max=''
			this.powerMin=''
			this.powerMax=''
		}
		this.isfrist = true
        this.openFullScreen1()
		let self = this
		//加载灯具类型
		this.$http.get("/api/lampTypes/json", {}, function(res) {
			if (res.success) {
			self.lampTypeList = res.data;
			}
		});
 		var echarts1 = document.getElementById("echarts")
		    echarts1.style.width=(window.innerWidth - 370)+'px';
      	var myChart = this.$echarts.init(echarts1);

		var refTypeStr = '1,2,3,4,5' 
        var temp = ''
        for(var i =0;i<this.chooseEchatType.length;i++){
            temp += this.chooseEchatType[i] + ","
        }
		refTypeStr = temp.substring(0,temp.length-1)
		
        var params = {
			detetionIds:this.ids,
			refTypeStr:refTypeStr,
        	lampType:this.searchLampType,
		}
		var objparams  ={
			powerMin:this.powerMin,
			powerMax:this.powerMax,
			lightIntensity3Min:this.lightIntensity3Min,
			lightIntensity3Max:this.lightIntensity3Max	
		}

        this.$http.postQueryObj('/api/contestStatistics/contestIndexForSupplierJson/'+this.colorFlag+'/'+this.contestId,params,objparams,function(res){
			var data = res.data
          self.fullscreenLoading = false;
			var length = data.indexList.length;
				
		    	 var  powerMax =0;
		    	 var lightIntensity3Max = 0;
		    	 var lightIntensity7Min = 10000000;
		    	 var lightIntensity7Max = 0;
		    	 var lightIntensity9Min = 100000;
		    	 var lightIntensity9Max = 0;
		    	 var  brandName ='';
		    	  
		     if(data.detectionList){
		    	 
		    	 console.log(data.detectionList.length);
		    	 
		    	 var dataBJ =[];
		    
					for(var i=0 ;i<data.detectionList.length;i++){
					
						var detection = data.detectionList[i];
						var dataChild =[];
						brandName = detection.brandName;
						
						dataChild.push(detection.power);   //功率
                        dataChild.push(detection.lightIntensity6); //垂直上30°(cd)
                        dataChild.push(detection.lightIntensity9); //垂直下10°水平左60°(cd)
                        dataChild.push(detection.lightIntensity3); //下45°(cd)
                        dataChild.push(detection.lightIntensity10); //垂直下10°水平右60°(cd)
                        dataChild.push(detection.lightIntensity7); //下10°(cd)
                        dataChild.push(detection.posCode); //pocode
						dataBJ.push(dataChild);
					
						if(detection.power>powerMax){
							powerMax =detection.power;
						}
						
						if(detection.lightIntensity3>lightIntensity3Max){
							lightIntensity3Max =detection.lightIntensity3;
						}
						
						if(detection.lightIntensity7 > lightIntensity7Max){
							lightIntensity7Max =detection.lightIntensity7
						}
						if(detection.lightIntensity7 < lightIntensity7Min){
							lightIntensity7Min =detection.lightIntensity7
						}
						
						if(detection.lightIntensity9 > lightIntensity9Max){
							lightIntensity9Max =detection.lightIntensity9
						}
						if(detection.lightIntensity9 < lightIntensity9Min){
							lightIntensity9Min =detection.lightIntensity9
						}
					}
				}
				
				
	     if(data.otherDetectionList){
		    	 var dataOther =[];
		    	
					for(var i=0 ;i<data.otherDetectionList.length;i++){
						var detection = data.otherDetectionList[i];
						var dataChildOther =[];
						dataChildOther.push(detection.power);   //功率
                        dataChildOther.push(detection.lightIntensity6); //垂直上30°(cd)
                        dataChildOther.push(detection.lightIntensity9); //垂直下10°水平左60°(cd)
                        dataChildOther.push(detection.lightIntensity3); //下45°(cd)
                        dataChildOther.push(detection.lightIntensity10); //垂直下10°水平右60°(cd)
                        dataChildOther.push(detection.lightIntensity7); //下10°(cd)
                        dataChildOther.push(detection.posCode); //pocode
						dataOther.push(dataChildOther);
						
						if(detection.power>powerMax){
							powerMax =detection.power;
						}
						
						
						if(detection.lightIntensity3>lightIntensity3Max){
							lightIntensity3Max =detection.lightIntensity3;
						}
						
						if(detection.lightIntensity7 > lightIntensity7Max){
							lightIntensity7Max =detection.lightIntensity7
						}
						if(detection.lightIntensity7 < lightIntensity7Min){
							lightIntensity7Min =detection.lightIntensity7
						}
						
						if(detection.lightIntensity9 > lightIntensity9Max){
							lightIntensity9Max =detection.lightIntensity9
						}
						if(detection.lightIntensity9 < lightIntensity9Min){
							lightIntensity9Min =detection.lightIntensity9
						}
					}
				}
				
				

			

				          var schema = [
				              {name: 'power', index: 0, text: '功率'},
				              {name: 'lightnessAve', index: 1, text: '垂直上30°'},
				              {name: 'lightnessMax', index: 2, text: '垂直下10°水平左60°'},
				              {name: 'evenness', index: 3, text: '下45°'},
				              {name: 'posCode', index: 4, text: '垂直下10°水平右60°'},
				              {name: 'posCode', index: 5, text: '下10°'}
                          ];
                          
				          var itemStyle = {
				              normal: {
				                  opacity: 0.8,
				                  shadowBlur: 10,
				                  shadowOffsetX: 0,
				                  shadowOffsetY: 0,
				                  shadowColor: 'rgba(0, 0, 0, 0.5)'
				              }
				          };

				          var option = {
				              backgroundColor: '#f6f6fd',
				              color: [
				                  '#dd4444', '#008000', '#80F1BE'
				              ],
				              legend: {
				                  y: 'top',
				                  data: [brandName,'其他'],
				                  textStyle: {
				                    //   color: '#fff',
				                      fontSize: 16
				                  }
				              },
				              grid: {
				                  x: '10%',
				                  x2: 150,
				                  y: '18%',
				                  y2: '10%'
				              },
				              tooltip: {
				                  padding: 10,
				                  backgroundColor: '#222',
				                  borderColor: '#777',
				                  borderWidth: 1,
				                  formatter: function (obj) {
				                	var value = obj.value;
                					var poscode = obj.data[6]
				                		//  if( obj.seriesName!='其他'){
							                      return '<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
							                          + poscode + ' ' + value[0] + '瓦：'
							                          + '</div>'
							                          + schema[2].text + '：' + value[2] + '<br>'
							                          + schema[3].text + '：' + value[3] + '<br>'
							                          + schema[5].text + '：' + value[5] + '<br>';
				                		//  }else{
				                		// 	if(poscode!=null && poscode.length>4){
				                		// 		poscode = poscode.substring(0,4)+"******";
				                		// 	}
				                			 
				                		// 	  return '<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
					                    //       + poscode + ' 瓦：'
					                    //       + '</div>'
					                    //       + schema[2].text + '：*'+'<br>'
					                    //       + schema[3].text + '：*' + '<br>'
					                    //       + schema[5].text + '：*' + '<br>';
				                		//  }
				                  }
				              },
				              xAxis: {
				                  type: 'value',
				                  name: '功率(W)',
				                  nameGap: 16,
				                  nameTextStyle: {
				                    //   color: '#fff',
				                      fontSize: 14
				                  },
				                  max: powerMax,
				                  splitLine: {
				                      show: false
				                  },
            						scale:true,
				                  axisLine: {
				                      lineStyle: {
				                        //   color: '#eee'
				                      }
				                  }
				              },
				              yAxis: {
				                  type: 'value',
				                  name: '下45°(cd)',
				                  //max :120,
				                  nameLocation: 'end',
				                  nameGap: 20,
				                  data: lightIntensity3Max,
				                  nameTextStyle: {
				                    //   color: '#fff',
				                      fontSize: 16
				                  },
				                  axisLine: {
				                      lineStyle: {
				                        //   color: '#eee'
				                      }
				                  },
            						scale:true,
				                  splitLine: {
				                      show: false
				                  }
				              },
				              visualMap: [
				                  {
				                      left: 'right',
				                      top: '10%',
				                      dimension: 3,
				                      min: lightIntensity7Min,
				                      max: lightIntensity7Max,
				                      itemWidth: 30,
				                      itemHeight: 120,
				                      calculable: true,
				                      precision:2,
				                      text: ['圆形大小：下10°(cd)'],
				                      textGap: 30,
				                      textStyle: {
				                        //   color: '#fff'
				                      },
				                      inRange: {
				                          symbolSize: [10, 70]
				                      },
				                      outOfRange: {
				                          symbolSize: [10, 70],
				                          color: ['rgba(255,255,255,.2)']
				                      },
				                      controller: {
				                          inRange: {
				                              color: ['#c23531']
				                          },
				                          outOfRange: {
				                              color: ['#444']
				                          }
				                      }
				                  },
				                  {
				                      left: 'right',
				                      bottom: '15%',
				                      dimension:2,//指定用数据的『哪个维度』，映射到视觉元素上。『数据』即 series.data。 可以把 series.data 理解成一个二维数组，
				                      min: lightIntensity9Min,
				                      max: lightIntensity9Max,
				                      itemHeight: 120,
				                      calculable: true,
				                      precision: 0,
				                      text: ['明暗：下10° 左60°(cd)'],
				                      textGap: 30,
				                      textStyle: {
				                        //   color: '#fff'
				                      },
				                      inRange: {
				                          colorLightness: [0.9, 0.5]
				                      },
				                      outOfRange: {
				                          color: ['rgba(255,255,255,.2)']
				                      },
				                      controller: {
				                          inRange: {
				                              color: ['#c23531']
				                          },
				                          outOfRange: {
				                              color: ['#444']
				                          }
				                      }
				                  }
				              ],
				              series: [
								  {
				                      name: '其他',
				                      type: 'scatter',
				                      itemStyle: itemStyle,
				                      data: dataOther
				                  },
				                  {
				                      name: brandName,
				                      type: 'scatter',
				                      itemStyle: itemStyle,
				                      data: dataBJ
				                  }
				                  
				              ]
				          };
			// console.log(JSON.stringify(option))
			myChart.clear();
			myChart.setOption(option);

          setTimeout(function (){
	        	    window.onresize = function () {
	        	    	myChart.resize();
	        	    }
	        },200)
			
        })
    }
  }
}
</script>
<style>
    .top{
        margin-bottom: 20px;
        
    }
    .button{
            background-color: #5b65a1;
            border-radius: 4px;
            color: #fff;
            padding: 12px 20px;
            font-size: 14px;
            border: none;
            margin-right: 20px;
            cursor: pointer;
        }
    </style>